import React, { memo, useState, useMemo, createRef, useEffect } from 'react'
import Modal from 'Components/modal'
import Button from 'Components/button'
import Toast from './custom-toast'
import { Image } from 'Components/view-image'
import { uploadImg, submitFeedback } from './services'
import { imageItem } from './types'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import xss from 'xss'
interface Props {
  visible: boolean
  onClose: () => void
}
//发送 按钮的  埋点
function sendBtnTea(button_name: string) {
  sendTeaCommEvent('clk_event', {
    event_id: 'common_feedback_window_btn',
    button_name,
  })
}
const FeedbackModal: React.FC<Props> = ({ visible, onClose }) => {
  const [uploading, setUploading] = useState(false)
  const [content, setContent] = useState('')
  const [tel, setTel] = useState('')
  const [waringVisible, setWarnVisible] = useState<{
    empty: boolean
    tel_valid: boolean
  }>({
    empty: false,
    tel_valid: false,
  }) //内容为空警告是否可见
  const [isSubmit, setSubmit] = useState(false)

  const [imgList, setList] = useState<imageItem[]>([]) // 测试 数据
  //input 引用
  const inputRef = createRef<HTMLInputElement>()

  //内容的长度
  const contentLength = useMemo(() => content.length, [content])
  const telLength = useMemo(() => tel.length, [tel])
  //最大长度
  const maxLength = 300
  const isOutRange = useMemo(() => contentLength > 300, [contentLength])

  //窗口 关闭  清楚所有的数据
  function closeHandler() {
    onClose()
    setContent('')
    setTel('')
    setList([])
    setSubmit(false)
    setWarnVisible({
      empty: false,
      tel_valid: false,
    })
    sendBtnTea('取消')
  }
  //提及
  async function submit() {
    sendBtnTea('提交')
    let empty = false
    let tel_valid = false
    contentLength === 0 && (empty = true)
    tel && !/^1[34578]\d{9}$/.test(tel) && (tel_valid = true)

    if (empty || tel_valid) {
      setWarnVisible({
        empty,
        tel_valid,
      })
      return
    }
    if (isOutRange) return
    const res = await submitFeedback(tel, xss.filterXSS(content), imgList) //添加 xss 防御
    if (res.success && res.data.err_code === 0) {
      closeHandler()
      setSubmit(true)
    } else {
      Toast.error(
        {
          title: '反馈失败',
          isModal: false,
          getContainer: () => document.body,
        },
        1000
      )
    }
  }
  //保证 modal 关闭 并且成功提及 成功  才显示弹框
  useEffect(() => {
    if (!visible && isSubmit) {
      Toast.success(
        {
          title: '反馈成功',
          isModal: false,
          getContainer: () => document.body,
        },
        1500
      )
    }
  }, [isSubmit])
  //图片选择
  async function imgChoose(files: FileList | null) {
    if (inputRef.current) {
      // 切换修改一下type 否则 不能提交同一个图片
      inputRef.current.type = 'text'
      inputRef.current.type = 'file'
    }
    if (!files || files.length === 0) {
      return
    }

    // 最大不能超过5M
    if (files[0]?.size > 1024 * 1024 * 5) {
      Toast.error(
        {
          title: '图片不能超过5Mb',
          isModal: false,
          getContainer: () => document.body,
        },
        1000
      )
      return
    }
    try {
      setUploading(true)
      const res = await uploadImg(files[0])
      setUploading(false)
      if (res.success) {
        const { height, width, url_list } = res.data.data
        setList([
          ...imgList,
          {
            image_height: height,
            image_width: width,
            image_uri: url_list[0].url,
          },
        ])
        return
      }
    } catch (error) {
      console.error(error)
    }
    setUploading(false)
    Toast.error(
      {
        title: '上传图片异常请重试',
        isModal: false,
        getContainer: () => document.body,
      },
      1000
    )
  }
  const footer = (
    <section className="footer">
      <Button
        style={{
          border: 'solid 0.5px #c9cbd6',
        }}
        className="btn cancel"
        onClick={() => closeHandler()}
      >
        取消
      </Button>
      <Button type="new_primary" className="btn submit" onClick={submit}>
        提交
      </Button>
    </section>
  )
  // 模态框 展示就 出发埋点
  useEffect(() => {
    if (visible) {
      // 埋点 触发
      sendTeaCommEvent('show_event', {
        event_id: 'common_feedback_window',
      })
    }
  }, [visible])

  return (
    <div className="feedback-modal-wapper">
      <Modal
        visible={visible}
        timeout={{
          appear: 100,
          enter: 100,
          exit: 0,
        }}
        closable={true}
        onClose={() => {
          closeHandler()
        }}
        title="用户反馈"
        height={685}
        width={528}
        getContainer={() =>
          document.querySelector('.feedback-modal-wapper') as HTMLElement
        }
        className="feedback-modal"
        footer={footer}
      >
        <section className="feedback-form">
          <div className="form-item">
            <div className="title">
              <div className="text">
                <span className="required-icon">*</span> 问题描述
              </div>
            </div>
            <div
              className={[
                'input',
                'textarea-wapper',
                isOutRange || waringVisible.empty ? 'input warning-box' : '',
              ].join(' ')}
            >
              <textarea
                rows={2}
                placeholder="请描述您反馈的内容或遇到的问题"
                autoFocus={true}
                spellCheck={false}
                maxLength={maxLength}
                onChange={(e) => {
                  setContent(e.target.value)
                  if (e.target.value.length > 0 && waringVisible) {
                    setWarnVisible({
                      ...waringVisible,
                      empty: false,
                    })
                  }
                }}
              />
              {/* 字数统计和 超限提示 */}
              <div
                className={['count-wapper', isOutRange ? 'warning' : ''].join(
                  ' '
                )}
              >
                {isOutRange && <span>字数已超限</span>}
                <span className="count">{`${contentLength}/${maxLength}`}</span>
              </div>
              {/* 提交时 内容为空提示 */}
              {waringVisible.empty && (
                <div className="empty warning">还未填写问题描述</div>
              )}
            </div>
          </div>
          <div className="form-item">
            <div className="title title-flex">
              <span className="text">联系方式</span>
              <span className="desc">
                请留下您的电话号码以便工作人员取得联系
              </span>
            </div>
            <div className="input">
              <input
                type="text"
                className="tel"
                onChange={(e) => setTel(e.target.value)}
                spellCheck={false}
                maxLength={11}
                value={tel}
                placeholder="请输入手机号"
              />
              {telLength > 0 && (
                <div
                  className="clear-wapper"
                  onClick={() => {
                    setTel('')
                    setWarnVisible({
                      ...waringVisible,
                      tel_valid: false,
                    })
                  }}
                >
                  <span className="clear-icon" />
                </div>
              )}
              {waringVisible.tel_valid && (
                <div className="tel-valid warning">电话号码格式不正确</div>
              )}
            </div>
          </div>
          <div className="form-item">
            <div className="title title-flex">
              <span className="text">相关图片</span>
              <span className="desc">
                可上传 JPG/JPEG/PNG格式，单张图片不超过5Mb，最多传3张图片
              </span>
            </div>
            <div className="input img-choose">
              {imgList.map((item, index) => {
                return (
                  <div className="img-item" key={item.image_uri}>
                    <Image
                      src={item.image_uri}
                      height={144}
                      width={144}
                      style={{
                        width: '144px',
                        height: '144px',
                      }}
                    />
                    <div
                      className="remove"
                      onClick={() => {
                        imgList.splice(index, 1)
                        setList([...imgList])
                      }}
                    >
                      <span className="remove-icon" />
                    </div>
                  </div>
                )
              })}

              {imgList.length < 3 && (
                <section
                  className="img-add"
                  onClick={() => inputRef.current?.click()}
                >
                  <div className={`wapper ${uploading ? 'loading' : ''}`}>
                    <div className="img-icon" />
                    <div className="text">
                      {uploading ? '上传中...' : '添加图片'}
                    </div>
                  </div>
                  <input
                    type="file"
                    style={{
                      display: 'none',
                    }}
                    accept="image/png,image/jpeg,image/jpg"
                    ref={inputRef}
                    onChange={(e) => imgChoose(e.target.files)}
                  />
                </section>
              )}
            </div>
          </div>
        </section>
      </Modal>
      <style jsx>
        {`
          .feedback-modal-wapper {
            font-family: PingFangSC;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
          }
          .feedback-modal-wapper :global(.feedback-modal .modal-title) {
            text-align: left;
          }
          .feedback-modal-wapper :global(.feedback-modal) {
            z-index: 99999;
          }
          :global(.modal-container) {
            border-radius: 4px;
          }
          :global(.feedback-modal .footer) {
            display: flex;
            justify-content: space-between;
          }
          :global(.feedback-modal .modal-container .modal-header) {
            padding: 24px 40px;
          }
          :global(.feedback-modal .modal-container .modal-body) {
            padding: 0 40px;
          }
          :global(.feedback-modal .modal-container .modal-footer) {
            padding: 24px 40px;
          }
          :global(.feedback-modal .modal-container .modal-close:hover) {
            color: #e62021;
          }
          :global(.feedback-modal .footer .btn) {
            width: 220px;
            height: 44px;
            border-radius: 2px;
            line-height: 44px;
            font-size: 16px;
          }
          :global(.feedback-modal .footer .btn.cancel:hover) {
            background-color: #e6e8f2;
            color: #1f2129;
          }
          :global(.feedback-modal .footer .btn.submit:hover) {
            background-color: #f5c530;
            color: #1f2129;
          }
          :global(.feedback-modal .modal-container .modal-close) {
            font-size: 20px;
            width: 20px;
            height: 20px;
          }
          .form-item {
            margin-top: 14px;
          }
          .form-item:first-of-type {
            margin-top: 0;
          }
          .form-item .title {
            margin-bottom: 12px;
          }
          .form-item .text {
            font-size: 14px;
            font-weight: 500;
          }
          .img-item {
            position: relative;
          }
          .img-item .remove {
            position: absolute;
            top: 0;
            right: 0;
            height: 20px;
            width: 20px;
            border-radius: 2px;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          }
          :global(.feedback-modal .img-item img) {
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, 0.06);
          }
          .remove .remove-icon {
            height: 12px;
            width: 12px;
            display: block;
            background: url(${require('./static/remove.png')}) no-repeat 0 0 /
              cover;
          }
          .title-flex {
            display: flex;
            justify-content: start;
            align-items: center;
          }
          .form-item .desc {
            font-size: 12px;
            color: #979aa8;
            margin-left: 16px;
          }
          .required-icon {
            color: #e62021;
            font-size: 14px;
            font-family: PingFangSC;
          }
          textarea {
            width: 100%;
            padding: 12px 16px 8px;
            height: 160px;
            resize: none; /*隐藏右下角的缩放按钮 */
            border-radius: 2px;
            border: solid 1px #f7f8fc;
            background-color: #f7f8fc;
          }
          textarea:focus {
            outline: none;
          }
          .input.textarea-wapper {
            border: 1px solid transparent;
            padding-bottom: 10px;
          }
          .input.warning-box {
            border-color: red;
          }
          textarea::placeholder,
          input::placeholder {
            font-size: 14px;
            line-height: 1.43;
            color: #979aa8;
          }
          .input {
            position: relative;
            background: #f7f8fc;
            border-radius: 2px;
          }
          .count-wapper {
            position: absolute;
            bottom: 1px;
            right: 16px;
            font-size: 12px;
            line-height: 1.43;
            color: #979aa8;
          }
          .count {
            margin-left: 8px;
            font-size: 12px;
          }
          .warning {
            color: #e62021;
          }
          .empty {
            position: absolute;
            left: 16px;
            bottom: 8px;
            font-size: 12px;
          }
          .tel {
            width: 448px;
            height: 54px;
            border-radius: 2px;
            background-color: #f7f8fc;
            padding: 17px 17px 17px 16px;
          }
          .tel:focus {
            outline: none;
          }
          .tel-valid {
            position: absolute;
            right: 40px;
            bottom: 8px;
            font-size: 12px;
            top: 50%;
            transform: translateY(-50%);
          }
          .clear-wapper:hover {
            background-color: #1f2129;
          }
          .clear-wapper {
            position: absolute;
            right: 16px;
            top: 50%;
            transform: translateY(-50%);
            height: 16px;
            width: 16px;
            border-radius: 50%;
            background-color: rgba(0, 0, 0, 0.4);
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .clear-wapper .clear-icon {
            height: 10px;
            width: 10px;
            display: block;
            background: url(${require('./static/remove.png')}) no-repeat 0 0 /
              cover;
          }
          .img-choose {
            display: flex;
            background: none;
          }
          .img-add {
            width: 144px;
            height: 144px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 2px;
            border: dashed 0.5px #c9cbd6;
            cursor: pointer;
          }
          .img-add:hover {
            background-color: #f7f8fc;
          }
          :global(.img-choose > *) {
            margin-left: 8px;
          }
          :global(.img-choose *:first-child) {
            margin-left: 0px;
          }

          .img-add .wapper {
            display: flex;
            align-items: center;
            flex-direction: column;
          }
          .img-add .img-icon {
            height: 24px;
            width: 24px;
            background: url(${require('./static/img.png')}) no-repeat 0 0 /
              cover;
            margin-bottom: 4px;
          }
          .loading .img-icon {
            height: 24px;
            width: 24px;
            background: url(${require('./static/loading.gif')}) no-repeat 0 0 /
              cover;
            margin-bottom: 4px;
          }
          .img-add .text {
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: normal;
            color: #979aa8;
          }
        `}
      </style>
    </div>
  )
}

export default memo(FeedbackModal)
